import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Box,
} from "@mui/material";
import { baseWhite } from "../utility/colorPalette";

export const AddToHomeScreenEntry = () => {
  return (
    <Box
      sx={{
        maxWidth: 600,
        margin: "auto",
        mx: 2,
        my: 4,
        border: 1,
        borderRadius: 2,
        borderColor: "primary.main",
        p: 1.5,
        backgroundColor: baseWhite,
      }}
    >
      <Typography variant="h6" gutterBottom>
        ダウンロード方法
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        gutterBottom
        sx={{ textAlign: "left" }}
      >
        このサービスはアプリとしてダウンロードすることができます。ご利用の端末に応じた追加方法をご確認ください。
      </Typography>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={2}>
        <Button
          variant="outlined"
          fullWidth
          href="/how-to-add-ios"
          sx={{ textTransform: "none" }}
        >
          iPhoneをお使いの方
        </Button>
        <Button
          variant="outlined"
          fullWidth
          href="/how-to-add-other"
          sx={{ textTransform: "none" }}
        >
          Androidをお使いの方
        </Button>
      </Stack>
    </Box>
  );
};
